import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_TICKET_POSTPONE_PROCESS,
  CLEAR_TICKET_POSTPONE_PROCESSES,
  FLAG_GETTING_TICKET_POSTPONE_PROCESSES,
  FLAG_TICKET_POSTPONE_PROCESS_ACTIVITY,
  GET_TICKET_POSTPONE_PROCESS,
  GET_TICKET_POSTPONE_PROCESSES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_TICKET_POSTPONE_PROCESSES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_TICKET_POSTPONE_PROCESSES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_TICKET_POSTPONE_PROCESSES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_TICKET_POSTPONE_PROCESS_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_TICKET_POSTPONE_PROCESS:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_TICKET_POSTPONE_PROCESS:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
